import { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { paymentStatusService } from '../services/PaymentStatusService';
import { paymentSessionService } from '../services/paymentSessionService';
import { trackEvent } from '../lib/analytics';
import { trackNaturaBusinessEvent } from '../lib/naturaVisitorTracking';

const StatusHandler = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    const handleStatus = async () => {
      const status = searchParams.get('status')?.toLowerCase();
      const token = searchParams.get('token');

      if (!token) {
        console.warn('No token provided');
        navigate('/');
        return;
      }

      console.log('Handling payment status:', { status, token });

      try {
        // The URL is only a navigation hint. Mollie remains the authority for every status.
        const finalStatus = await paymentStatusService.checkInitialStatus(token);

        console.log('Final status:', finalStatus);

        switch (finalStatus.toLowerCase()) {
          case 'paid':
          case 'completed': {
            const session = paymentSessionService.getSession(token);
            trackEvent('purchase_status_paid', {
              token,
            });
            trackNaturaBusinessEvent('purchase_status_paid', {
              service_id: session?.serviceId || '',
              service_name: session?.serviceName || '',
              value: Number(session?.amount || 0),
              currency: session?.currencyCode || '',
              payment_type: session?.paymentType || '',
            });
            navigate(`/merci?token=${token}`);
            break;
          }
          case 'cancel':
          case 'canceled':
          case 'fail':
          case 'failed':
            trackEvent('purchase_status_failed', {
              token,
              status: finalStatus,
            });
            paymentSessionService.clearSession(token);
            navigate('/');
            break;
          case 'pending':
          default:
            trackEvent('purchase_status_pending', {
              token,
              status: finalStatus,
            });
            navigate(`/attente?token=${token}`);
            break;
        }
      } catch (error) {
        console.error('Error handling payment status:', error);
        navigate('/');
      }
    };

    handleStatus();
  }, [searchParams, navigate]);

  return null;
};

export default StatusHandler;
